import { BaseModel } from "../../ensue-react-system/utilities/base-model";
import {
  IUser,
  IUserCompetitionRole,
  IUserRole,
  IUserTeamRole,
} from "./i-user";
import { IAuthorizationPolicy } from "./i-authorization-policy";

export class User extends BaseModel implements IUser {
  public id: number = 0;
  public firstName: string = "";
  public lastName: string = "";
  public middleName: string = "";
  public email: string = "";
  public fullName: string = "";
  public avatar: string = "";
  public status: number = 0;
  public relations: {
    player: boolean;
    teams: Array<number>;
    matches: Array<number>;
    competitions: Array<number>;
  } = { player: false, teams: [], competitions: [],matches:[] };
  public policies: IAuthorizationPolicy[] = [];
  public roles: IUserRole[] = [];
  public userCompetitionsRoles: IUserCompetitionRole[] = [];
  public userTeamsRoles: IUserTeamRole[] = [];

  public constructor(props: { [key: string]: any } | undefined = undefined) {
    super(props);
    this.__init(props);
  }
}
